import * as React from 'react'
import styled from 'styled-components'

import { headerHeight } from '../LayoutStyles'
import { withRouter, RouteComponentProps } from 'react-router'
import CloseButton from '../../Shared/CloseButton'

const FeatureContainer = styled.div`
  position: absolute;
  top: ${headerHeight};
  bottom: 0;
  left: 0;
  right: 0;
  padding-right: 20px;
  padding-left: 20px;
  overflow: auto;
  background-color: rgba(255, 255, 255, 0.75);

  .close-button {
    float: right;
  }

  .feature-content {
    position: relative;
    margin: 0 auto;
    max-width: 1400px;
    padding: 56px 40px 40px;
    z-index: 1001;
    background: ${({ theme }) => theme.feature.background};
  }

  .feature-title {
    color: ${({ theme }) => theme.colors.default};
    font-weight: bold;
    font-size: ${({ theme }) => theme.fonts.titleSize};
    margin-bottom: 25px;
    display: inline-flex;
  }
`

export const TwoRows = styled.div`
  display: flex;
  flex-direction: row;
`

type Props = RouteComponentProps<{}>

type State = {
  modalOpened: boolean
}

class Common extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { modalOpened: false }
  }

  componentDidMount() {
    window.addEventListener('mousedown', this.handleClick)
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.handleClick)
  }

  handleClick = e => {
    const container = document.getElementById('feature-content')
    if (container && !container.contains(e.target)) {
      this.props.history.goBack()
    }
  }

  render() {
    return (
      <FeatureContainer>
        <div className="feature-content" id="feature-content">
          <CloseButton
            className="close-button"
            onClick={() => this.props.history.goBack()}
          >
            x
          </CloseButton>
          {this.props.children}
        </div>
      </FeatureContainer>
    )
  }
}

export default withRouter(Common)



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/Common.tsx